import Vue from 'vue'
import Router from 'vue-router'
// Views - Pages
import Page404 from '@/views/errorPages/Page404'
// import receives from '@/views/receives'
// import creatuser from '@/views/creatuser'
import Full from '@/views/Full'
// import Full from '@/views/index'
import settinguser from '@/views/settinguser'
// import product from '@/views/order/product'
import proVue from '@/views/order/proVue'
import yitijiao from '@/views/order/yitijiao'
import tijiao from '@/views/order/tijiao'
import qutuihuo from '@/views/order/qutuihuo'
import zengtui from '@/views/order/zengtui'

// import diaobo from '@/views/stock/diaobo'
// import kong from '@/views/stock/kong'
// import diaobo2 from '@/views/stock/diaobo2'
import zengdiao from '@/views/stock/zengdiao'
// import diaochu from '@/views/stock/diaochu'
// import diaochudan from '@/views/stock/diaochudan'
// import huowei from '@/views/stock/huowei'
// import huowei2 from '@/views/stock/huowei2'
import huowei3 from '@/views/stock/huowei3'
import zengwei from '@/views/stock/zengwei'
// import weimingxi from '@/views/stock/weimingxi'
import kucun from '@/views/stock/kucun'
import exportlist from '@/views/stock/exportlist'
// import pandian from '@/views/stock/pandian'
import pandi2 from '@/views/stock/pan2'
import zengpan from '@/views/stock/zengpan'
import diaobofahuo from '@/views/stock/diaobofahuo'
import xiaochu from '@/views/stock/xiaochu'
import zengxiao from '@/views/stock/zengxiao'
// import qutuihuo from '@/views/stock/qutuihuo'
import authority from '@/views/system/authority'
import loginfo from '@/views/system/loginfo'
import menuManage from '@/views/system/menuManage'
import roleManage from '@/views/system/roleManage'
import userManage from '@/views/system/userManage'
import AddUser from '@/views/system/AddUser'
import AddRole from '@/views/system/AddRole'
// import AddRole2 from '@/views/system/AddRole2'
import rqinggou from '@/views/receives/qinggou'
import reportForms from '@/views/receives/reportForms'
import rdiaobo from '@/views/receives/diaobo'
import gudingsh from '@/views/receives/gudingsh'
import receiveOrder from '@/views/receives/receiveOrder'
import index from '@/components/index'
// import sidebar from '@/components/NavHeader'
// import SidebarNav from '@/components/SidebarNav'
// import SidebarNavN from '@/components/SidebarNavn'

Vue.use(Router)

const router = new Router({
  // base:'/dist',
  // mode:'history',
  routes: [

    // {
    //   path: '/ui/bgtest',
    //   name: 'bgtest',
    //   component: bgtest,

    // },
    {
      path: '/ui/login',
      name: 'login',
      component: index,

    },
    // {path: '/ui/sidebar',name: '侧边栏',component: SidebarNav},
    // {path: '/ui/sidebar2',name: '侧边栏2',component: SidebarNavN},
    {
    path: '/ui',
    // redirect: '/ui/receives',
    redirect: '/ui/receives/rqinggou',
    name: '首页',
    component: Full,
    children: [
      // {path: '/ui/receives',name: '门店收货',component: receives},
      {path: '/ui/receives',name: '门店收货',redirect: '/ui/receives/rqinggou',component:{render (c) { return c('router-view') }},
         children: [
                    {path: 'rqinggou',name: '商品采购入库',component: rqinggou},
                    {path: 'rdiaobo',name: '商品调拨入库',component: rdiaobo},
                    {path: 'gudingsh',name: '固定资产收货',component: gudingsh},
                    {path: 'receiveOrder',name: '已收货订单',component: receiveOrder},
                    {path: 'portForms',name: '库存收发流水报表',component: reportForms}
                    ]
      },
      {path: '/ui/stock',name: '库存变更',redirect: '/ui/stock/kucun',component:{render (c) { return c('router-view') }
      },
      // component: {render (c) { return c('router-view') } },
          children: [
                    {path: 'kucun',name: '结存表单',component: kucun},
                    {path: 'exportlist',name: '导出单据',component: exportlist},
                    // {path: 'kong',name: '空',component: kong},
                    // {path: 'huowei0',name: '货位调整0',component: huowei},
                    // {path: 'huowei2',name: '货位调整2',component: huowei2},
                    {path: 'huowei',name: '货位调整',component: huowei3},
                    // {path: 'huowei2/weimingxi',name: '货位明细',component: weimingxi},
                    // {path: 'huowei2/zengwei',name: '新增调整',component: zengwei},
                    {path: 'huowei/zengwei',name: '新调货位',component: zengwei},
                    // {path: 'diaobo0',name: '申请调拨',component: diaobo},
                    // {path: 'diaobo',name: '申请调拨2',component: diaobo2},
                    // {path: 'diaobo/zengdiao',name: '新增申请',component: zengdiao},
                    // {path: 'diaochu',name: '确认调拨',component: diaochu},
                    // {path: 'diaochu/diaochudan',name: '填写调出单',component:diaochudan },
                    {path: 'diaofahuo',name: '调拨发货',component:diaobofahuo },
                    // {path: 'pandian',name: '库存盘点0',component: pandian},
                    {path: 'pandi',name: '库存盘点',component: pandi2},
                    {path: 'pandi/zengpan',name: '新增盘点单',component: zengpan},
                    {path: 'xiaochu',name: '货品出库单',component: xiaochu},
                    {path: 'xiaochu/zengxiao',name: '新增货品出库单',component: zengxiao},
                    // {path: 'qutuihuo',name: '去退货',component: qutuihuo}
                  ]
      },
      {path: '/ui/order',name: '门店请购单',redirect: '/ui/order/product',component:{render (c) { return c('router-view') }
      },
      // component: {render (c) { return c('router-view') }},
          children: [ {path: 'product',name: '去采购申请',component: proVue},
                    {path: 'tijiao',name: '提交采购申请',component: tijiao},
                    {path: 'yitijiao',name: '已提交',component: yitijiao},
                    {path: 'qutuihuo',name: '商品退货',component: qutuihuo},
                    {path: 'qutuihuo/zengtui',name: '新增退货单',component: zengtui}
                  ]
      },
       {path: '/ui/system',name: '系统管理',redirect: '/ui/system/authority',component:{render (c) { return c('router-view') }
      },
      // component: {render (c) { return c('router-view') }},
          children: [ {path: 'authority',name: '用户管理',component: authority},
                    {path: 'authority/AddUser',name: '新增用户',component: AddUser},
                    {path: 'menuManage',name: '菜单管理',component: menuManage},
                    {path: 'roleManage',name: '角色管理',component: roleManage},
                    {path: 'roleManage/AddRole',name: '新增角色',component: AddRole},
                    {path: 'loginfo',name: '查看日志',component: loginfo}
                  ]
      },
      // {path: '/ui/creatuser', name: '注册用户',component: creatuser},
      {path: '/ui/settinguser', name: '用户设置',component: settinguser},
      {path: '*', name: '页面失踪',component: Page404}
    ]
  },
      // {path: '*', name: '页面失踪',component: Page404}
  ]
})

// 判断是否登录
router.beforeEach((to, from, next) => {
var user = localStorage.getItem("userInfo");
// console.log("路由中打印user："+JSON.stringify(user));
// console.log(to.path+",name:"+to.name);
 if (user!=null||to.name =='login') {// 判断是否登录或者在登录页
    next()
 }else if(to.path=='/ui/login'){
  console.log("打印是否进来");
     next()
 } else{// 没登录则跳转到登录界面
    next({
      path: '/ui/login',
      query: {msg:-1}
    })
 }
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js